module.exports = __webpack_public_path__ + "static/media/gallery_08_t.bda4a585.jpg";